interface CallCenterCredentialsWithoutSecret {
    Provider: string,
    ExternalUsername: string,
}

interface CallCenterUserCredentialsWithSecret {
    Provider: string,
    ExternalUsername: string,
    Secret: string
}

interface GetUserCallCenterSettingsResponse {
    Active: boolean,
    AutoOpenPatientOnSingleMatch: boolean
    AskForAccountAtLogin: boolean
    Credentials: CallCenterCredentialsWithoutSecret | null
}

interface UpdateUserCallCenterCredentialsRequest {
    Credentials: CallCenterUserCredentialsWithSecret | null
}

interface UpdateUserCallCenterCredentialsResponse {
    Credentials: CallCenterCredentialsWithoutSecret
}

interface UpdateUserCallCenterOptionsRequest {
    Active: boolean,
    AutoOpenPatientOnSingleMatch: boolean
}

class CallCenterUserSettingsState {
    public Options: CallCenterOptionsState;
    public Credentials: CallCenterUserCredentialsState | null;

    public constructor(init?: Partial<CallCenterUserSettingsState>) {
        Object.assign(this, init);
    }

    public static fromResponse(response: GetUserCallCenterSettingsResponse): CallCenterUserSettingsState {
        return new CallCenterUserSettingsState({
            Options: CallCenterOptionsState.fromResponse(response),
            Credentials: CallCenterUserCredentialsState.fromResponse(response.Credentials)
        });
    }
}

class CallCenterOptionsState {
    public Active: boolean;
    public AutoOpenPatientOnSingleMatch: boolean;
    public AskForAccountAtLogin: boolean;

    public constructor(init?: Partial<CallCenterOptionsState>) {
        Object.assign(this, init);
    }

    public static fromResponse(response: GetUserCallCenterSettingsResponse): CallCenterOptionsState {
        return new CallCenterOptionsState({
            Active: response.Active,
            AutoOpenPatientOnSingleMatch: response.AutoOpenPatientOnSingleMatch,
            AskForAccountAtLogin: response.AskForAccountAtLogin
        });
    }
}

class CallCenterUserCredentialsState {
    public Provider: string;
    public ExternalUsername: string;
    public Secret: string | null;

    public constructor(init?: Partial<CallCenterUserCredentialsState>) {
        Object.assign(this, init);
    }

    public static fromResponse(response: CallCenterCredentialsWithoutSecret): CallCenterUserCredentialsState {
        if (response == null) {
            return null;
        }
        return new CallCenterUserCredentialsState({
            Provider: response.Provider,
            ExternalUsername: response.ExternalUsername,
            Secret: null
        });
    }
}

const ProviderTypes = {
    ComUnik: "ComUnik"
};

export
{
    CallCenterOptionsState,
    CallCenterUserCredentialsState,
    CallCenterUserCredentialsWithSecret,
    CallCenterUserSettingsState,
    GetUserCallCenterSettingsResponse,
    ProviderTypes,
    UpdateUserCallCenterCredentialsRequest,
    UpdateUserCallCenterCredentialsResponse,
    UpdateUserCallCenterOptionsRequest
};
